module.exports = __webpack_public_path__ + "img/retail-onboarding-grid-tile.f72c3e27.jpg";